module.exports = __webpack_public_path__ + "static/media/level-up-alt.cc1fea7c.svg";